import copy from "copy-to-clipboard";

const copyToClipBoard = (text: string) => {
  copy(text, { format: "text/plain" });
};

export default copyToClipBoard;
